import BreakpointsEnum from '../enums/breakpointsEnum';

$(function () {
    let App = window.App;
    App.login = {};
    App.login.ajax = false;

    App.login.openModal = function () {
        if ($('#loginModal').length) {
            return false;
        }

        let prevRequest = App.login.ajax;

        App.login.ajax = $.ajax({
            type: 'POST',
            url: '/auth/login-modal',
            beforeSend: function () {
                if (prevRequest) {
                    prevRequest.abort();
                }
            },
            success: function (response) {
                if (response.hasOwnProperty('modal_view')) {
                    $('footer').before(response.modal_view);
                    App.modal.open($('#loginModal'));
                }
            },
            complete: function () {
                App.login.ajax = false;
            }
        });
    }

    $(document).on('submit', '#loginForm', function (e) {
        e.preventDefault();

        let $form = $(this);
        let $button = $form.find('button[type="submit"]');
        let prevRequest = App.login.ajax;

        App.login.ajax = $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function () {
                if (prevRequest) {
                    prevRequest.abort();
                }

                $button.addClass('is-loading');
            },
            success: function (response) {
                if (response.status === 'ERROR') {
                    $form.validate().showErrors({
                        'email': response.error
                    });

                    return false;
                }

                if (response.status === 'OK') {
                    if (window.App.getBreakpoint() === BreakpointsEnum.tablet || window.App.getBreakpoint() === BreakpointsEnum.mobile) {
                        document.location.replace(response.url_sm);
                    } else {
                        document.location.replace(response.url);
                    }
                }
            },
            complete: function () {
                App.login.ajax = false;
                $button.removeClass('is-loading');
            }
        });
    });
});